<template>
  <b-card no-body class="border-top-0 border-left-0 border-right-0 rounded-0">
    <b-card-header
      header-tag="header"
      class="p-0 border-0 rounded-0 bg-transparent"
      role="tab"
    >
      <button
        v-b-toggle="isOpen ? undefined : segment.segmentId"
        class="w-100 btn btn-ghost d-flex align-items-center"
        style="gap: 5px"
        @click="onOpen"
      >
        <vb-icon
          name="check_circle"
          :color="everyoneSeated ? color_success : '#adb5bd'"
          :size="16"
          :icon_style="{
            '--color': everyoneSeated ? color_success : '#adb5bd',
          }"
        ></vb-icon>
        <span :class="`flex-grow text-left ${isOpen ? 'semibold' : ''}`">
          {{ formatSegmentLabel(segment) }}
        </span>
        <vb-icon
          name="chevron-down"
          :size="16"
          :icon_style="{ transform: `rotate(${isOpen ? 180 : 0}deg)` }"
        ></vb-icon>
      </button>
    </b-card-header>
    <b-collapse :id="segment.segmentId" :visible="isOpen" role="tabpanel">
      <b-card-body class="pt-1">
        <div class="d-none d-lg-flex d-xl-flex flex-column" style="gap: 5px">
          <slot name="flight"></slot>
          <slot name="deck"></slot>
          <slot name="passengers"></slot>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { formatSegmentLabel } from "@liveflight/utilities/mixins";
import { color_success } from "@liveflight/resources/colors";

export default {
  name: "seat-navigation-accordion-block",
  props: {
    segment: Object,
    everyoneSeated: Boolean,
    isOpen: Boolean,
    onOpen: Function,
  },
  data() {
    return {
      color_success,
    };
  },
  methods: {
    formatSegmentLabel,
  },
};
</script>

<style lang="scss"></style>
